export default async function get_gpx_string_for_trail(trail) {
    if (!trail)
        throw new Error(`Cannot Get GPS Track | Trail not specified`);
    if (!trail.gpx_file_url)
        throw new Error(`Cannot Get GPS Track | GPX File not specified`);
    return fetch(trail.gpx_file_url)
    .then(body => body.text());
}

